import React from "react";
import { SelectInput } from "components/form";
import { useStaticCollection } from "utils/hooks";

export default (props) => {
  const collection = useStaticCollection("/selects/main_education_statuses.json");
  
  const prefix = props.prefix || {
    id: "main_education_status",
    name: "main_education_status",
  };

  return (
    <div className="form-group">
      <SelectInput
        {...props}
        placeholder="Selecione..."
        name={prefix.name}
        id={prefix.id}
        collection={collection}
        label={props.label || "Qual é a sua situação atual?"}
      />
    </div>
  )
}